import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { reactIcons } from "../../utils/icons";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import InfoModal from "../modals/InfoModal";

const Header = ({ toggleSidebar, isVerify }) => {
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state?.user || {});
  const [openInfo, setOpenInfo] = useState(false);
  const getToken = Cookies.get(`accessToken1`);

  return (
    <>
      <div className="h-[80px] w-full z-[9999] bg-black border-b border-[#FFE3E3]">
        <div className="flex lg:items-center justify-between gap-3 cursor-pointer px-3 py-3">
          <div
            onClick={() => {
              const cookeiData = Cookies.get(`accessToken1`);
              if (cookeiData && !isVerify) {
                navigate("/kyc");
              } else if (cookeiData) {
                navigate("/dashboard");
              } else {
                navigate("/");
              }
            }}
            className="flex items-center gap-2"
          >
            <div>
              <img
                src="/images/logo/main.png"
                alt="logo"
                className="w-[55px]"
              />
            </div>

            <div>
              <img
                src="/images/logo/sad.png"
                alt="logo"
                className="w-[180px]"
              />
              <p className="text-[8px] text-white mt-1  text-center">
                YOUR PATH TO A DECENTRALIZED FUTURE
              </p>
            </div>
          </div>

          {getToken && (
            <div className="hidden lg:flex gap-4">
              <div
                className="hidden lg:flex items-center"
                onClick={() => navigate("/profile")}
              >
                <span className="bg-[#69CEA6] text-white p-2 rounded-full mr-2">
                  {reactIcons.user}
                </span>
                <div>
                  <p className="text-white text-16 capitalize mr-2 font-semibold">
                    {userData?.firstname + " " + userData?.lastname || "N/A"}{" "}
                  </p>
                  <p className="text-[#69CEA6] mr-2 text-12 font-semibold">
                    {userData?.meta?.referredAs == "PowerFranchise"
                      ? "Power Franchise"
                      : userData?.meta?.referredAs == "Franchise" &&
                        userData?.uplineFranchiseCount >= 2
                      ? "Distributor"
                      : userData?.meta?.referredAs == "User"
                      ? ""
                      : userData?.meta?.referredAs || "N/A"}{" "}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="pr-1 sm:flex gap-3 lg:hidden">
            {getToken && (
              <button
                onClick={() => setOpenInfo(true)}
                className="w-10 h-10 flex-center mt-1  text-white bg-common rounded-full text-3xl"
              >
                {reactIcons.support}
              </button>
            )}
            <button
              onClick={toggleSidebar}
              className="w-10 h-10 flex-center mt-1 text-white bg-common rounded-full text-3xl"
            >
              {reactIcons.toggle}
            </button>
          </div>
        </div>
      </div>
      {
        <InfoModal
          open={openInfo}
          setOpen={setOpenInfo}
          message={
            "NOTE : Please ensure you provide your registered email address, as the support system will not be able to assist you without it."
          }
          type={"two"}
        />
      }
    </>
  );
};
export default Header;
